import { Icon } from "@chakra-ui/react";
import React from "react";

export default function ShipTruck(props) {
  return (
    <Icon
      width="52px"
      height="52px"
      viewBox="0 0 52 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0 9.75V13H30.875V37.375H20.8715C20.1467 34.5816 17.6345 32.5 14.625 32.5C11.6155 32.5 9.10325 34.5816 8.3785 37.375H6.5V29.25H3.25V40.625H8.3785C9.10325 43.4184 11.6155 45.5 14.625 45.5C17.6345 45.5 20.1467 43.4184 20.8715 40.625H34.3785C35.1032 43.4184 37.6155 45.5 40.625 45.5C43.6345 45.5 46.1468 43.4184 46.8715 40.625H52V27.3715L51.8976 27.1164L48.6476 17.3664L48.295 16.25H34.125V9.75H0ZM1.625 16.25V19.5H16.25V16.25H1.625ZM34.125 19.5H45.9566L48.75 27.8281V37.375H46.8715C46.1468 34.5816 43.6345 32.5 40.625 32.5C37.6155 32.5 35.1032 34.5816 34.3785 37.375H34.125V19.5ZM3.25 22.75V26H13V22.75H3.25ZM14.625 35.75C16.4401 35.75 17.875 37.1849 17.875 39C17.875 40.8151 16.4401 42.25 14.625 42.25C12.8099 42.25 11.375 40.8151 11.375 39C11.375 37.1849 12.8099 35.75 14.625 35.75ZM40.625 35.75C42.4401 35.75 43.875 37.1849 43.875 39C43.875 40.8151 42.4401 42.25 40.625 42.25C38.8099 42.25 37.375 40.8151 37.375 39C37.375 37.1849 38.8099 35.75 40.625 35.75Z"
        fill="#AB7D00"
      />
    </Icon>
  );
}
